export default __webpack_public_path__ + "9785681a1e6ec9981a673add549d1cc0.jpg";